<mat-tab-group animationDuration="400ms">
  <mat-tab label="Associados">
    <div class="py-2 mt-3">
      @if (tableSource.data.length > 0) {
        <div>
          <div class="tab-overflow">
            <table
              #tableAssociate
              mat-table
              [dataSource]="tableSource"
              class="mat-elevation-z8"
            >
              @for (column of columnsAssociateClient; track column.keyColumn) {
                <ng-container matColumnDef="{{ column.keyColumn }}">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ column.description }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (column.keyColumn == 'action' && validClient(element)) {
                      <div class="flex justify-center items-center gap-3">
                        @if (column.key.remove) {
                          @if (!loadingBIcon) {
                            <mat-icon
                              class="btn-icon-remove-outline"
                              fontIcon="do_not_disturb_on"
                              matTooltip="Desassociar"
                              (click)="removeItem(element)"
                            />
                          } @else {
                            <mat-spinner [diameter]="24" mode="indeterminate" />
                          }
                        }
                      </div>
                    }@else if (column.keyColumn == 'cpf') {
                      {{ element[column.key] | cpf }}
                    }@else if (column.keyColumn == 'cnpj') {
                        @if(element.razaoSocial == 'PF'){
                          {{ element[column.key] | cpf }}
                        }@else{
                          {{ element[column.key] | cnpj }}
                        }
                    }@else if(column.keyColumn == 'corporate_name') {
                        {{ element[column.key] == 'PF' ? '-' : element[column.key]}}
                    }  @else {
                      {{ element[column.key] }}
                    }
                  </td>
                </ng-container>
              }
              <tr
                mat-header-row
                class="style-header"
                *matHeaderRowDef="displayedColumns"
              ></tr>
              <tr
                mat-row
                class="style-row"
                *matRowDef="let row; columns: displayedColumns"
              ></tr>
            </table>
          </div>
        </div>
      }
      <mat-paginator
        #paginator
        [pageSizeOptions]="[1, 5, 10, 20, 50]"
        [pageSize]="rowsAssociateClient"
      >
      </mat-paginator>
    </div>
  </mat-tab>
  <mat-tab label="Não associados">
    <div class="py-2 mb-3">
      @if (true) {
        <form-client-search
          [search]="inputSearchClient"
          [listSearch]="listSearch"
          (responseSearch)="search($event)"
        />
      }
      @if (!loadingClient) {
        @if (totalClient > 0) {
          <div>
            <table-list-disassociated-sub-client
              [dataSource]="listClient"
              [columns]="columnsClient"
              [loading]="loadingBIcon"
              [listClient]="true"
              [listAssociateClient]="listAssociateClient"
              (addItemEvent)="addItem($event)"
              (removeItemEvent)="removeItem($event)"
            />
          </div>
        } @else {
          <div>
            <h3 class="text-center">Nenhum cliente.</h3>
          </div>
        }
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <div [hidden]="loadingClient || totalClient == 0">
        <mat-paginator
          #paginatorNotClient
          [length]="totalClient"
          [pageSizeOptions]="[1, 5, 10, 20, 50]"
          [pageSize]="rowsClient"
          [pageIndex]="pageClient - 1"
          (page)="pageChanged($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
